'use strict';

const _ = require('lodash');

function omitMissingAttributeClasses(missingAttributes) {
    return _.map(missingAttributes, (missingAttribute) => {
        return _.omit(missingAttribute, '_class');
    });
}

function omitCalculatedValueClasses(calculatedValues) {
    return _.map(calculatedValues, (calculatedValue) => {
        return _.omit(calculatedValue, 'class');
    });
}

/**
 * Omit attribute class fields on the validation response.
 * @param validationResponse The response produced from validating a V2 RuleSet which was converted from a V1 RuleSet.
 */
function omitClasses(validationResponse) {
    if (!_.isUndefined(validationResponse.missingAttributes)) {
        validationResponse.missingAttributes = omitMissingAttributeClasses(validationResponse.missingAttributes);
    }

    if (!_.isUndefined(validationResponse.calculatedValues)) {
        validationResponse.calculatedValues = omitCalculatedValueClasses(validationResponse.calculatedValues);
    }

    return validationResponse;
}

function populateViolatedExclusions(validationResponse, v1Rules) {
    if (!_.isUndefined(validationResponse.violatedExclusions)) {
        validationResponse.violatedExclusions = _.map(validationResponse.violatedExclusions, (violatedExclusionName) => {
            const v1Rule = _.find(v1Rules, (rule) => rule.name === violatedExclusionName);

            let violatedExclusion;
            if (_.isNil(v1Rule)) {
                violatedExclusion = {name: violatedExclusionName};
            }
            else {
                violatedExclusion = v1Rule;
            }

            return violatedExclusion;
        });
    }

    return validationResponse;
}

class ValidationResponseAdapter {
    static convert(validationResponse, v1Rules) {
        validationResponse = omitClasses(validationResponse);
        validationResponse = populateViolatedExclusions(validationResponse, v1Rules);

        return validationResponse;
    }
}

module.exports = ValidationResponseAdapter;
